"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  ProgrammingBrowser1: ['programming-browser-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7.019,15.47A.75.75,0,1,0,8.08,16.53l2.5-2.5a.749.749,0,0,0,0-1.06l-2.5-2.5a.75.75,0,0,0-1.061,1.06l1.793,1.793a.25.25,0,0,1,0,.354Z', 'M12.55,15.75h4a.75.75,0,0,0,0-1.5h-4a.75.75,0,0,0,0,1.5Z', 'M24,4.75a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3v14.5a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3Zm-14.346-1a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5.969.969,0,0,1-.154.5.966.966,0,0,1-1.692,0,.969.969,0,0,1-.154-.5A.969.969,0,0,1,9.654,3.75Zm-3.5,0a.966.966,0,0,1,1.692,0A.969.969,0,0,1,8,4.25a.969.969,0,0,1-.154.5.966.966,0,0,1-1.692,0A.969.969,0,0,1,6,4.25.969.969,0,0,1,6.154,3.75Zm-3.562.092A1,1,0,0,1,3.5,3.25a.985.985,0,0,1,.846.5.969.969,0,0,1,.154.5.969.969,0,0,1-.154.5.966.966,0,0,1-1.692,0,.969.969,0,0,1-.154-.5A.979.979,0,0,1,2.592,3.842ZM22,19.25a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7a.25.25,0,0,1,.25-.25h19.5A.25.25,0,0,1,22,7Z']],
  ProgrammingHoldCode1: ['programming-hold-code-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,15.542v7.25a1,1,0,0,0,2,0v-7.25a1,1,0,0,0-2,0Z', 'M3,15.792v6.5a.5.5,0,0,0,.5.5H14.264A2.239,2.239,0,0,0,16.5,20.555v-.263a1,1,0,0,0-1-1H6.375a.625.625,0,0,1,0-1.25H8.9a1,1,0,0,0,.92-1.393,2.234,2.234,0,0,0-2.056-1.357H3.5A.5.5,0,0,0,3,15.792Z', 'M17.866,10.842a1.251,1.251,0,0,0,1.768,0l4-4a1.249,1.249,0,0,0,0-1.767l-4-4a1.25,1.25,0,1,0-1.768,1.767l2.763,2.763a.5.5,0,0,1,0,.707L17.866,9.075A1.249,1.249,0,0,0,17.866,10.842Z', 'M10.634,1.075a1.249,1.249,0,0,0-1.768,0l-4,4a1.249,1.249,0,0,0,0,1.767l4,4a1.25,1.25,0,1,0,1.768-1.767L7.871,6.312a.5.5,0,0,1,0-.707l2.763-2.763A1.249,1.249,0,0,0,10.634,1.075Z', 'M13.251,11.708a1.252,1.252,0,0,0,1.22-.978l2-9a1.251,1.251,0,0,0-2.442-.543l-2,9a1.252,1.252,0,0,0,.95,1.492A1.264,1.264,0,0,0,13.251,11.708Z']],
  ProgrammingHoldLaptop1: ['programming-hold-laptop-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M3.365,13.279h11.77a3.062,3.062,0,0,0,3.115-3,.5.5,0,0,0-.5-.5H17a.25.25,0,0,1-.25-.25v-7.1A1.649,1.649,0,0,0,15.1.779H3.4A1.649,1.649,0,0,0,1.75,2.426v7.1a.25.25,0,0,1-.25.25H.75a.5.5,0,0,0-.5.5A3.062,3.062,0,0,0,3.365,13.279Zm.385-10.5h11v6.75a.25.25,0,0,1-.25.25H4a.25.25,0,0,1-.25-.25Z', 'M12.816,16.726a.251.251,0,0,1-.153.053H9.25a1,1,0,0,0,0,2h4a.5.5,0,0,1,0,1h-4a1.994,1.994,0,0,1-1.785-1.113.5.5,0,0,0-.29-.252L3.75,17.279a2.479,2.479,0,0,0-2.412.478.514.514,0,0,0,.085.86c11.33,5.731,7.851,5.672,18.1,2.236a.5.5,0,0,1,.424.051l3.417,2.135a.25.25,0,0,0,.383-.212V17.588a.5.5,0,0,0-.276-.448L20.6,15.7a4,4,0,0,0-1.789-.422H16.75A6.947,6.947,0,0,0,12.816,16.726Z']],
  ProgrammingKeyboardType: ['programming-keyboard-type', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.93,11.42a1.071,1.071,0,0,0,1.038-1.329l-1.6-6.418a1.07,1.07,0,0,0-1.038-.81H2.674a1.07,1.07,0,0,0-1.038.81l-1.6,6.418A1.071,1.071,0,0,0,1.07,11.42H3.133a.5.5,0,0,0,.305-.1,1.717,1.717,0,0,1,1.051-.371.466.466,0,0,0,.4-.219A1.76,1.76,0,0,1,6.578,9.9a.5.5,0,0,0,.387-.123,1.764,1.764,0,0,1,2.869.822.5.5,0,0,0,.254.3,1.724,1.724,0,0,1,.47.358.5.5,0,0,0,.363.156h2.908a.5.5,0,0,0,.363-.156,1.74,1.74,0,0,1,.469-.358.5.5,0,0,0,.254-.3,1.764,1.764,0,0,1,2.869-.822.5.5,0,0,0,.387.123,1.8,1.8,0,0,1,.194-.011,1.778,1.778,0,0,1,1.5.835.467.467,0,0,0,.4.219,1.717,1.717,0,0,1,1.051.371.5.5,0,0,0,.3.1ZM4,7.891H3a.75.75,0,0,1,0-1.5H4a.75.75,0,0,1,0,1.5Zm1.5-2.5h-1a.75.75,0,0,1,0-1.5h1a.75.75,0,0,1,0,1.5ZM8,7.891H7a.75.75,0,0,1,0-1.5H8a.75.75,0,0,1,0,1.5Zm2.75-3.25a.75.75,0,0,1-.75.75H9a.75.75,0,0,1,0-1.5h1A.75.75,0,0,1,10.75,4.641Zm2.5,2.5a.75.75,0,0,1-.75.75h-1a.75.75,0,0,1,0-1.5h1A.75.75,0,0,1,13.25,7.141Zm.25-1.75a.75.75,0,0,1,0-1.5h1a.75.75,0,0,1,0,1.5Zm3.75,1.75a.75.75,0,0,1-.75.75h-1a.75.75,0,0,1,0-1.5h1A.75.75,0,0,1,17.25,7.141Zm.5-2.5a.75.75,0,0,1,.75-.75h1a.75.75,0,0,1,0,1.5h-1A.75.75,0,0,1,17.75,4.641Zm3.5,2.5a.75.75,0,0,1-.75.75h-1a.75.75,0,0,1,0-1.5h1A.75.75,0,0,1,21.25,7.141Z', 'M19.523,12.922h0l-.42-1.474a.767.767,0,1,0-1.475.421h0l-.28-.984a.793.793,0,0,0-.95-.526.77.77,0,0,0-.525.948l.281.982h0a.791.791,0,0,0-.948-.526.767.767,0,0,0-.526.948l1.259,4.409a.251.251,0,0,1-.339.3l-.73-.312h0a.613.613,0,0,0-.638,1.036s1.15,1.262,2.376,2.352h0a2.616,2.616,0,0,0,2.4.548l1.639-.469A2.553,2.553,0,0,0,22.4,17.416L21,12.5a.79.79,0,0,0-.948-.527A.768.768,0,0,0,19.523,12.922Z', 'M5.247,12.905h0l.42-1.475a.768.768,0,0,1,1.476.422h0l.28-.984a.792.792,0,0,1,.949-.526.769.769,0,0,1,.526.948l-.282.982h0a.792.792,0,0,1,.948-.526.767.767,0,0,1,.527.948L8.832,17.1a.25.25,0,0,0,.338.3L9.9,17.09h0a.613.613,0,0,1,.638,1.035s-1.149,1.263-2.376,2.353h0a2.617,2.617,0,0,1-2.4.548l-1.64-.469A2.553,2.553,0,0,1,2.37,17.4l1.4-4.914a.79.79,0,0,1,.948-.527A.767.767,0,0,1,5.247,12.905Z']],
  ProgrammingUser: ['programming-user', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11,0a1,1,0,0,0,0,2H21.5a.5.5,0,0,1,.5.5v11a.5.5,0,0,1-.5.5h-8a1,1,0,0,0,0,2H22a2,2,0,0,0,2-2V2a2,2,0,0,0-2-2Z', 'M11.97,9.47a.75.75,0,1,0,1.06,1.06l2.5-2.5a.749.749,0,0,0,0-1.06l-2.5-2.5a.75.75,0,0,0-1.06,1.06l1.793,1.793a.252.252,0,0,1,0,.354Z', 'M16.5,10.75H20a.75.75,0,0,0,0-1.5H16.5a.75.75,0,0,0,0,1.5Z', 'M5.08,7.733A5.086,5.086,0,0,0,0,12.813v3.055a.5.5,0,0,0,.5.5H2.111a.248.248,0,0,1,.249.225l.7,6.958a.5.5,0,0,0,.5.45H6.607a.5.5,0,0,0,.5-.45l.7-6.958a.249.249,0,0,1,.249-.225H9.66a.5.5,0,0,0,.5-.5V12.813A5.086,5.086,0,0,0,5.08,7.733Z', 'M8.537,3.609a3.3,3.3,0,1,0-3.3,3.3A3.3,3.3,0,0,0,8.537,3.609Z']],
  ProgrammingUserChat: ['programming-user-chat', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,1.75A1.752,1.752,0,0,0,22.25,0h-10A1.752,1.752,0,0,0,10.5,1.75v8a1.752,1.752,0,0,0,1.75,1.75.25.25,0,0,1,.25.25v2a.749.749,0,0,0,.75.75.742.742,0,0,0,.488-.181l3.219-2.759a.249.249,0,0,1,.163-.06h5.13A1.752,1.752,0,0,0,24,9.75ZM16.78,5.78l-2,2a.75.75,0,0,1-1.06-1.06l1.293-1.293a.252.252,0,0,0,0-.354L13.72,3.78a.75.75,0,1,1,1.06-1.06l2,2A.749.749,0,0,1,16.78,5.78ZM20.75,8h-2.5a.75.75,0,0,1,0-1.5h2.5a.75.75,0,0,1,0,1.5Z', 'M5.08,9.77A5.086,5.086,0,0,0,0,14.85V17.9a.5.5,0,0,0,.5.5H2.135a.25.25,0,0,1,.248.216l.676,4.948A.5.5,0,0,0,3.554,24H6.606a.5.5,0,0,0,.5-.433l.675-4.948a.25.25,0,0,1,.248-.216H9.66a.5.5,0,0,0,.5-.5V14.85A5.086,5.086,0,0,0,5.08,9.77Z', 'M5.242,8.941a3.3,3.3,0,1,0-3.295-3.3A3.295,3.295,0,0,0,5.242,8.941Z']],
  ProgrammingTeamChat3: ['programming-team-chat-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7.524,22.092a.25.25,0,0,0-.06-.322A3.929,3.929,0,0,0,5,20.9a3.98,3.98,0,0,0-3.791,2.774.253.253,0,0,0,.037.224.25.25,0,0,0,.2.1H6.623a.25.25,0,0,0,.244-.194l.031-.139A5.531,5.531,0,0,1,7.524,22.092Z', 'M19,20.9a3.91,3.91,0,0,0-2.12.626.249.249,0,0,0-.074.348,5.417,5.417,0,0,1,.777,1.793l.031.139a.25.25,0,0,0,.244.194h4.7a.25.25,0,0,0,.2-.1.253.253,0,0,0,.037-.224A3.98,3.98,0,0,0,19,20.9Z', 'M15.793,24a.249.249,0,0,0,.238-.326,3.976,3.976,0,0,0-7.594.043A.219.219,0,0,0,8.646,24Z', 'M2.564 17.578 A2.436 2.436 0 1 0 7.436 17.578 A2.436 2.436 0 1 0 2.564 17.578 Z', 'M16.564 17.578 A2.436 2.436 0 1 0 21.436 17.578 A2.436 2.436 0 1 0 16.564 17.578 Z', 'M20.37,1.753A1.75,1.75,0,0,0,18.621,0l-13,0A1.75,1.75,0,0,0,3.87,1.75V8.505a3.754,3.754,0,0,0,1.1,2.652L8.09,14.28a.748.748,0,0,0,.53.22.735.735,0,0,0,.287-.057.748.748,0,0,0,.463-.693V11a.5.5,0,0,1,.5-.5h8.75a1.749,1.749,0,0,0,1.75-1.75ZM9.151,6.72A.75.75,0,1,1,8.09,7.78l-2-2a.749.749,0,0,1,0-1.06l2-2A.75.75,0,0,1,9.151,3.78L7.858,5.073a.25.25,0,0,0,0,.354Zm4.64-3.135-2,4a.75.75,0,1,1-1.342-.67l2-4a.75.75,0,1,1,1.342.67Zm4.36,1.135a.749.749,0,0,1,0,1.06l-2,2A.75.75,0,0,1,15.09,6.72l1.293-1.293a.25.25,0,0,0,0-.354L15.09,3.78a.75.75,0,0,1,1.061-1.06Z', 'M13.611,19.591a2.432,2.432,0,1,0-1.37.423A2.433,2.433,0,0,0,13.611,19.591Z']],
  ProgrammingUserChat2: ['programming-user-chat-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.245,11.5A1.752,1.752,0,0,0,24,9.75v-8A1.752,1.752,0,0,0,22.245,0h-11a1.752,1.752,0,0,0-1.75,1.75v8a1.752,1.752,0,0,0,1.75,1.75h1a.25.25,0,0,1,.25.25v2a.748.748,0,0,0,.75.75.744.744,0,0,0,.488-.181l3.219-2.759a.249.249,0,0,1,.163-.06Zm-6.47-5.72-2,2a.75.75,0,0,1-1.061-1.06l1.293-1.293a.25.25,0,0,0,0-.354L12.714,3.78a.75.75,0,0,1,1.061-1.06l2,2A.749.749,0,0,1,15.775,5.78Zm1.97.72h3a.75.75,0,0,1,0,1.5h-3a.75.75,0,0,1,0-1.5Z', 'M13.4,23.8a.5.5,0,0,0,.077-.443,5.412,5.412,0,0,0-.332-.844c-.429-.866-2.221-1.465-4.472-2.306-.608-.227-.509-1.5-.239-1.8A5.46,5.46,0,0,0,9.6,14.568,2.8,2.8,0,0,0,6.75,11.5,2.8,2.8,0,0,0,3.9,14.568,5.46,5.46,0,0,0,5.07,18.4c.27.3.369,1.575-.239,1.8C2.58,21.046.788,21.645.359,22.511a5.412,5.412,0,0,0-.332.844A.5.5,0,0,0,.505,24H13A.5.5,0,0,0,13.4,23.8Z']],
  ProgrammingUserHead: ['programming-user-head', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,23.375a7.009,7.009,0,0,0,7-7v-2a7,7,0,0,0-14,0v2A7.009,7.009,0,0,0,12,23.375ZM7.268,17.916l-.015-.048c.009-.3.6-.743,1.5-.743s1.5.451,1.5.75-.6.75-1.5.75C7.886,18.625,7.315,18.213,7.268,17.916ZM12,21.375a4.907,4.907,0,0,1-2.744-.844.251.251,0,0,1,.1-.455,2.865,2.865,0,0,0,2.149-1.322.251.251,0,0,1,.219-.129h.548a.251.251,0,0,1,.219.129,2.865,2.865,0,0,0,2.149,1.322.251.251,0,0,1,.1.455A4.907,4.907,0,0,1,12,21.375Zm4.732-3.459c-.047.3-.618.709-1.482.709-.9,0-1.5-.451-1.5-.75s.6-.75,1.5-.75,1.488.444,1.5.743ZM7,15.061a.25.25,0,0,1,.159-.233A5.372,5.372,0,0,0,9.63,12.861a.251.251,0,0,1,.187-.112.247.247,0,0,1,.2.078A7.628,7.628,0,0,0,16,15.125h.75a.25.25,0,0,1,.25.25v.277a.249.249,0,0,1-.342.232,3.849,3.849,0,0,0-1.408-.259A3.087,3.087,0,0,0,12.493,17a.251.251,0,0,1-.219.129h-.548A.249.249,0,0,1,11.507,17,3.087,3.087,0,0,0,8.75,15.625a3.849,3.849,0,0,0-1.408.259A.249.249,0,0,1,7,15.652Z', 'M22.5,4.625a.25.25,0,0,1-.25-.25v-2.5A1.252,1.252,0,0,0,21,.625h-.5a.75.75,0,0,0,0,1.5.25.25,0,0,1,.25.25v2a.25.25,0,0,1-.25.25.75.75,0,0,0,0,1.5h2a.75.75,0,0,0,0-1.5Z', 'M22.5,11.625a.25.25,0,0,1-.25-.25v-2.5A1.252,1.252,0,0,0,21,7.625h-.5a.75.75,0,0,0,0,1.5.25.25,0,0,1,.25.25v2a.25.25,0,0,1-.25.25.75.75,0,0,0,0,1.5h2a.75.75,0,0,0,0-1.5Z', 'M3.5,4.625a.25.25,0,0,1-.25-.25v-2.5A1.252,1.252,0,0,0,2,.625H1.5a.75.75,0,0,0,0,1.5.25.25,0,0,1,.25.25v2a.25.25,0,0,1-.25.25.75.75,0,0,0,0,1.5h2a.75.75,0,0,0,0-1.5Z', 'M1.5,19.625a.75.75,0,0,0,0,1.5h2a.75.75,0,0,0,0-1.5.25.25,0,0,1-.25-.25v-2.5A1.252,1.252,0,0,0,2,15.625H1.5a.75.75,0,0,0,0,1.5.25.25,0,0,1,.25.25v2A.25.25,0,0,1,1.5,19.625Z', 'M15.5,6.125a1.752,1.752,0,0,0,1.75-1.75v-2a1.75,1.75,0,0,0-3.5,0v2A1.752,1.752,0,0,0,15.5,6.125Zm-.25-1.75v-2a.25.25,0,0,1,.5,0v2C15.75,4.65,15.25,4.65,15.25,4.375Z', 'M21.5,21.125a1.752,1.752,0,0,0,1.75-1.75v-2a1.75,1.75,0,0,0-3.5,0v2A1.752,1.752,0,0,0,21.5,21.125Zm-.25-3.75a.25.25,0,0,1,.5,0v2c0,.275-.5.275-.5,0Z', 'M6.75,2.375v2a1.75,1.75,0,0,0,3.5,0v-2a1.75,1.75,0,0,0-3.5,0Zm2,0v2c0,.275-.5.275-.5,0v-2a.25.25,0,0,1,.5,0Z', 'M4.25,9.375a1.75,1.75,0,0,0-3.5,0v2a1.75,1.75,0,0,0,3.5,0Zm-1.5,2c0,.275-.5.275-.5,0v-2a.25.25,0,0,1,.5,0Z']],
  ProgrammingSearch: ['programming-search', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M-.27,10.755a10.98,10.98,0,0,0,17.322,8.983.5.5,0,0,1,.642.054l4.015,4.014a1.5,1.5,0,1,0,2.121-2.121l-4.023-4.023a.5.5,0,0,1-.056-.639A10.994,10.994,0,1,0-.27,10.755Zm11-9a9,9,0,1,1-9,9A9.01,9.01,0,0,1,10.73,1.755Z', 'M14.024,13.129a1,1,0,0,0,1.538,1.281l2.5-3a1,1,0,0,0,0-1.281l-2.5-3A1,1,0,0,0,14.024,8.41l1.834,2.2a.251.251,0,0,1,0,.32Z', 'M6.794,14.77a1,1,0,0,0,.768-1.641l-1.834-2.2a.251.251,0,0,1,0-.32l1.834-2.2A1,1,0,0,0,6.024,7.129l-2.5,3a1,1,0,0,0,0,1.281l2.5,3A1,1,0,0,0,6.794,14.77Z', 'M9.441,14.373a1.016,1.016,0,0,0,.352.064,1,1,0,0,0,.936-.649l2-5.334a1,1,0,1,0-1.873-.7l-2,5.334A1,1,0,0,0,9.441,14.373Z']],
  ProgrammingTeamChat1: ['programming-team-chat-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.237,13A3.73,3.73,0,0,0,16.9,19.638a.249.249,0,0,1-.044.417,4.956,4.956,0,0,0-2.6,3.334A.5.5,0,0,0,14.74,24H23.5a.5.5,0,0,0,.487-.611,4.949,4.949,0,0,0-2.473-3.264.25.25,0,0,1-.032-.419A3.724,3.724,0,0,0,19.237,13Zm1.738,3.737a1.735,1.735,0,0,1-3.453.245A.25.25,0,0,1,17.8,16.7a3.911,3.911,0,0,0,.522.037,4.481,4.481,0,0,0,2.224-.594.25.25,0,0,1,.365.151A1.655,1.655,0,0,1,20.975,16.737Z', 'M3.75,9.747A1.752,1.752,0,0,0,5.5,11.5h5.75a.5.5,0,0,1,.5.5V13.75a.75.75,0,0,0,.463.693.738.738,0,0,0,.287.057.746.746,0,0,0,.53-.22l2.634-2.636a.5.5,0,0,1,.354-.147H19.5a1.752,1.752,0,0,0,1.75-1.75v-8A1.752,1.752,0,0,0,19.5,0H5.5A1.752,1.752,0,0,0,3.75,1.75ZM15.47,4.28a.75.75,0,1,1,1.06-1.06l2,2a.749.749,0,0,1,0,1.06l-2,2a.75.75,0,1,1-1.06-1.06l1.293-1.293a.252.252,0,0,0,0-.354ZM10.829,7.415l2-4a.75.75,0,1,1,1.342.67l-2,4A.75.75,0,0,1,11.5,8.5a.741.741,0,0,1-.334-.079A.75.75,0,0,1,10.829,7.415ZM6.47,5.22l2-2A.75.75,0,1,1,9.53,4.28L8.237,5.573a.252.252,0,0,0,0,.354L9.53,7.22A.75.75,0,1,1,8.47,8.28l-2-2A.749.749,0,0,1,6.47,5.22Z', 'M.013,23.389A.5.5,0,0,0,.5,24H9.26a.5.5,0,0,0,.487-.611,4.955,4.955,0,0,0-2.612-3.341.251.251,0,0,1-.045-.418A3.734,3.734,0,1,0,1,16.737a3.71,3.71,0,0,0,1.5,2.976.25.25,0,0,1-.03.419A4.95,4.95,0,0,0,.013,23.389ZM3.061,16.3a.249.249,0,0,1,.145-.165.252.252,0,0,1,.219.014,4.485,4.485,0,0,0,2.225.594,3.911,3.911,0,0,0,.522-.037.252.252,0,0,1,.21.071.248.248,0,0,1,.07.21A1.734,1.734,0,0,1,3,16.737,1.655,1.655,0,0,1,3.061,16.3Z']],
  ProgrammingHoldCode2: ['programming-hold-code-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.5,22.678a.5.5,0,0,1,.148-.355c.567-.562,2.615-2.59,3.558-3.529a1,1,0,0,0,.294-.709V10.939a.5.5,0,0,0-.665-.472c-.73.256-1.8,1.389-1.834,5.829a.5.5,0,0,1-.147.35l-2.208,2.209a.25.25,0,0,1-.421-.233l.494-2.153c.343-1.438-.971-2.052-1.688-.938A23.457,23.457,0,0,0,15.5,19.492V23.75a.25.25,0,0,0,.25.25h3.5a.25.25,0,0,0,.25-.25Z', 'M8.25,24a.25.25,0,0,0,.25-.25V19.492a23.457,23.457,0,0,0-1.531-3.961c-.717-1.114-2.031-.5-1.688.938l.493,2.153a.25.25,0,0,1-.42.233L3.146,16.646A.5.5,0,0,1,3,16.3c-.032-4.44-1.1-5.573-1.834-5.829a.5.5,0,0,0-.665.472v7.105a1,1,0,0,0,.329.742c1.035.936,3,2.977,3.532,3.538a.5.5,0,0,1,.139.346v1.08a.25.25,0,0,0,.25.25Z', 'M15.616,8.866a1.25,1.25,0,0,0,1.768,1.768l4-4a1.251,1.251,0,0,0,0-1.768l-4-4a1.25,1.25,0,0,0-1.768,1.768L18.379,5.4a.5.5,0,0,1,0,.707Z', 'M8.384.866a1.251,1.251,0,0,0-1.768,0l-4,4a1.251,1.251,0,0,0,0,1.768l4,4A1.25,1.25,0,0,0,8.384,8.866L5.621,6.1a.5.5,0,0,1,0-.707L8.384,2.634A1.251,1.251,0,0,0,8.384.866Z', 'M10.729,11.471A1.331,1.331,0,0,0,11,11.5a1.253,1.253,0,0,0,1.22-.979l2-9A1.251,1.251,0,0,0,11.779.978l-2,9A1.253,1.253,0,0,0,10.729,11.471Z']],
  ProgrammingLaptopType: ['programming-laptop-type', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.966,18.831a.251.251,0,0,0,.115-.328l-.62-1.345A2.233,2.233,0,0,1,14.555,14.2c.762-.35,4.755.225,6,.416a.25.25,0,0,0,.222-.078.247.247,0,0,0,.058-.229L20,10.951V1.515a1.5,1.5,0,0,0-1.5-1.5H5.5A1.5,1.5,0,0,0,4,1.515v9.444l-.84,3.358a.252.252,0,0,0,.059.23.248.248,0,0,0,.223.077c1.245-.2,5.217-.79,6-.428a2.231,2.231,0,0,1,1.1,2.963L9.919,18.5a.251.251,0,0,0,.115.328,2.106,2.106,0,0,1,.716.588.252.252,0,0,0,.2.1h2.1a.248.248,0,0,0,.2-.1A2.119,2.119,0,0,1,13.966,18.831ZM6,9.015v-6a1,1,0,0,1,1-1H17a1,1,0,0,1,1,1v6a1,1,0,0,1-1,1H7A1,1,0,0,1,6,9.015Z', 'M9.176,16.531a.733.733,0,0,0-.358-.972,43.837,43.837,0,0,0-4.6.459c-.312-.01-.8-.009-.972.359l-2.04,3.467A2.439,2.439,0,0,0,2.4,23.08l1.479.681a2.44,2.44,0,0,0,2.345-.167C7.54,22.744,9.4,21.2,9.4,21.2a.586.586,0,0,0-.453-1.071l-1.2.551a.249.249,0,0,1-.281-.05.253.253,0,0,1-.051-.282Z', 'M20.755,16.377c-.169-.368-.66-.369-.972-.359a43.837,43.837,0,0,0-4.6-.459.733.733,0,0,0-.358.972l1.758,3.817a.253.253,0,0,1-.051.282.249.249,0,0,1-.281.05l-1.2-.551A.586.586,0,0,0,14.6,21.2s1.86,1.544,3.176,2.394a2.44,2.44,0,0,0,2.345.167L21.6,23.08a2.439,2.439,0,0,0,1.2-3.236Z']],
  ProgrammingUserChat1: ['programming-user-chat-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M.282,23.39a.5.5,0,0,0,.46.694H12.871a.507.507,0,0,0,.411-.238.533.533,0,0,0,.039-.485c-.041-.1-.083-.2-.132-.294-.454-.908-1.9-1.441-3.911-2.179h0l-.4-.145a.251.251,0,0,1-.163-.235v-.834a.251.251,0,0,1,.073-.177,2.619,2.619,0,0,0,.753-1.511.234.234,0,0,1,.052-.123,1.383,1.383,0,0,0,.245-.544,1.58,1.58,0,0,0-.138-1.159.248.248,0,0,1-.027-.2,4.474,4.474,0,0,0,.445-2.38c-.213-1.061-1.582-1.469-2.792-1.5a3.356,3.356,0,0,0-2.493.773.252.252,0,0,1-.137.086,1.243,1.243,0,0,0-.734.471,3.057,3.057,0,0,0-.018,2.522.253.253,0,0,1-.029.206,1.577,1.577,0,0,0-.15,1.176,1.382,1.382,0,0,0,.246.545.238.238,0,0,1,.052.123,2.619,2.619,0,0,0,.753,1.51.251.251,0,0,1,.073.177v.834a.248.248,0,0,1-.164.234l-.4.146C2.328,21.626.878,22.16.425,23.067.376,23.165.334,23.263.282,23.39Z', 'M11,11.416h.756a.5.5,0,0,1,.5.5v1.75a.75.75,0,0,0,1.238.569l3.149-2.7a.5.5,0,0,1,.326-.12h5.037a1.752,1.752,0,0,0,1.75-1.75v-8a1.752,1.752,0,0,0-1.75-1.75h-11a1.752,1.752,0,0,0-1.75,1.75v8A1.769,1.769,0,0,0,11,11.416Zm5.756-4.249a.75.75,0,0,1,.75-.75h3a.75.75,0,0,1,0,1.5h-3A.75.75,0,0,1,16.757,7.167ZM12.477,3.7a.75.75,0,0,1,1.06-1.061l2,2a.75.75,0,0,1,0,1.061l-2,2a.75.75,0,0,1-1.06-1.061L13.593,5.52a.5.5,0,0,0,0-.707Z']],
  ProgrammingMonitor: ['programming-monitor', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,3.005A2.548,2.548,0,0,0,21.5.416H2.5A2.548,2.548,0,0,0,0,3.005V16.916a3,3,0,0,0,3,3h7.25a.25.25,0,0,1,.25.25v1.168a.249.249,0,0,1-.25.25H5a1,1,0,0,0,0,2H19a1,1,0,0,0,0-2H12.75a.249.249,0,0,1-.25-.25V20.166a.25.25,0,0,1,.25-.25H21a3,3,0,0,0,3-3Zm-22,0a.55.55,0,0,1,.5-.589h19a.55.55,0,0,1,.5.589V14.916a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5Z', 'M11,7.166a.25.25,0,0,1-.25-.25v-2.5A1.251,1.251,0,0,0,9.5,3.166H9a.75.75,0,1,0,0,1.5.25.25,0,0,1,.25.25v2a.25.25,0,0,1-.25.25.75.75,0,0,0,0,1.5h2a.75.75,0,0,0,0-1.5Z', 'M20,13.166a.25.25,0,0,1-.25-.25v-2.5a1.251,1.251,0,0,0-1.25-1.25H18a.75.75,0,0,0,0,1.5.25.25,0,0,1,.25.25v2a.25.25,0,0,1-.25.25.75.75,0,0,0,0,1.5h2a.75.75,0,0,0,0-1.5Z', 'M7.25,13.916a.75.75,0,0,0-.75-.75.25.25,0,0,1-.25-.25v-2.5A1.251,1.251,0,0,0,5,9.166H4.5a.75.75,0,0,0,0,1.5.25.25,0,0,1,.25.25v2a.25.25,0,0,1-.25.25.75.75,0,0,0,0,1.5h2A.75.75,0,0,0,7.25,13.916Z', 'M20,7.166a.25.25,0,0,1-.25-.25v-2.5a1.251,1.251,0,0,0-1.25-1.25H18a.75.75,0,1,0,0,1.5.25.25,0,0,1,.25.25v2a.25.25,0,0,1-.25.25.75.75,0,0,0,0,1.5h2a.75.75,0,0,0,0-1.5Z', 'M5.5,3.166a1.752,1.752,0,0,0-1.75,1.75v2a1.75,1.75,0,0,0,3.5,0v-2A1.752,1.752,0,0,0,5.5,3.166Zm.25,3.75c0,.275-.5.275-.5,0v-2a.25.25,0,0,1,.5,0Z', 'M10,9.166a1.752,1.752,0,0,0-1.75,1.75v2a1.75,1.75,0,0,0,3.5,0v-2A1.752,1.752,0,0,0,10,9.166Zm.25,3.75c0,.275-.5.275-.5,0v-2a.25.25,0,0,1,.5,0Z', 'M14.5,3.166a1.752,1.752,0,0,0-1.75,1.75v2a1.75,1.75,0,0,0,3.5,0v-2A1.752,1.752,0,0,0,14.5,3.166Zm.25,3.75c0,.275-.5.275-.5,0v-2a.25.25,0,0,1,.5,0Z', 'M15.75,13.247A.25.25,0,0,1,15.5,13V10.5a1.251,1.251,0,0,0-1.25-1.25h-.5a.75.75,0,0,0,0,1.5A.25.25,0,0,1,14,11v2a.25.25,0,0,1-.25.25.75.75,0,0,0,0,1.5h2a.75.75,0,0,0,0-1.5Z']],
  ProgrammingUser1: ['programming-user-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11,.04a1,1,0,0,0,0,2H21.5a.5.5,0,0,1,.5.5v11a.5.5,0,0,1-.5.5h-8a1,1,0,0,0,0,2H22a2,2,0,0,0,2-2v-12a2,2,0,0,0-2-2Z', 'M11.97,9.51a.75.75,0,1,0,1.06,1.06l2.5-2.5a.749.749,0,0,0,0-1.06l-2.5-2.5a.75.75,0,0,0-1.06,1.06l1.793,1.793a.252.252,0,0,1,0,.354Z', 'M15.75,10.04a.75.75,0,0,0,.75.75H20a.75.75,0,0,0,0-1.5H16.5A.75.75,0,0,0,15.75,10.04Z', 'M0,12.948V16a.5.5,0,0,0,.5.5l1.612,0a.25.25,0,0,1,.249.225l.7,6.823a.5.5,0,0,0,.5.45H6.607a.5.5,0,0,0,.5-.45l.7-6.823a.25.25,0,0,1,.249-.225l1.612,0a.5.5,0,0,0,.5-.5V12.948a5.073,5.073,0,0,0-2.754-4.5A.25.25,0,0,1,7.4,8.006a4.3,4.3,0,1,0-4.423-.081.247.247,0,0,1,.117.227.252.252,0,0,1-.144.211A5.061,5.061,0,0,0,0,12.948Zm5.83-.867a.75.75,0,0,1-1.5,0V10.269a.75.75,0,0,1,1.5,0ZM2.947,4.3a2.207,2.207,0,0,1,.118-.707.251.251,0,0,1,.371-.131,5.439,5.439,0,0,0,2.9.838,5.431,5.431,0,0,0,1.067-.107.105.105,0,0,1,.09.023.106.106,0,0,1,.04.084,2.3,2.3,0,0,1-4.59,0Z']],
  ProgrammingUserWoman: ['programming-user-woman', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11,.02a1,1,0,0,0,0,2H21.75a.25.25,0,0,1,.25.25v11.5a.25.25,0,0,1-.25.25H13.5a1,1,0,0,0,0,2H22a2,2,0,0,0,2-2v-12a2,2,0,0,0-2-2Z', 'M13.03,10.55l2.5-2.5a.75.75,0,0,0,0-1.061l-2.5-2.5A.75.75,0,1,0,11.97,5.55l1.793,1.793a.25.25,0,0,1,0,.353L11.97,9.489a.75.75,0,1,0,1.06,1.061Z', 'M16.5,10.77H20a.75.75,0,0,0,0-1.5H16.5a.75.75,0,0,0,0,1.5Z', 'M1.8,12.412.021,18.323a.5.5,0,0,0,.479.644H2.6a.25.25,0,0,1,.249.222l.485,4.379a.5.5,0,0,0,.5.451h4.44a.5.5,0,0,0,.5-.451l.486-4.379a.252.252,0,0,1,.249-.222h2.1a.5.5,0,0,0,.477-.65l-1.858-5.876A4.326,4.326,0,0,0,8.065,9.622a.251.251,0,0,0-.337.1l-1.5,2.641a.249.249,0,0,1-.434,0c-1.328-2.336-.97-1.706-1.5-2.646a.25.25,0,0,0-.336-.1A4.288,4.288,0,0,0,1.8,12.412Z', 'M10.592,4.59a4.609,4.609,0,0,0-9.217,0A4.65,4.65,0,0,0,5.983,9.2,4.639,4.639,0,0,0,10.592,4.59Zm-7.109.728a.249.249,0,0,1,.173-.311A4.815,4.815,0,0,0,5.8,3.726a.249.249,0,0,1,.358,0A4.819,4.819,0,0,0,8.311,5.007a.25.25,0,0,1,.151.119.257.257,0,0,1,.022.192,2.6,2.6,0,0,1-5,0Z']],
  ProgrammingCode: ['programming-code', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,20.5a2.006,2.006,0,0,0,2,2H22a2.006,2.006,0,0,0,2-2V3.5a2.006,2.006,0,0,0-2-2H2a2,2,0,0,0-2,2ZM2.25,5A1.252,1.252,0,0,1,3.5,3.75H21A1.252,1.252,0,0,1,22.25,5V19.5A1.251,1.251,0,0,1,21,20.75H3.5A1.251,1.251,0,0,1,2.25,19.5Z', 'M20.75,5.75a.5.5,0,0,0-.5-.5h-16a.5.5,0,0,0-.5.5v13a.5.5,0,0,0,.5.5h16a.5.5,0,0,0,.5-.5ZM10.707,10.793a1,1,0,0,1,0,1.414l-2.5,2.5a1,1,0,1,1-1.414-1.414l1.616-1.616a.25.25,0,0,0,0-.354L6.793,9.707A1,1,0,1,1,8.207,8.293ZM17.5,13.5a1,1,0,0,1-1,1h-4a1,1,0,0,1,0-2h4A1,1,0,0,1,17.5,13.5Z']],
  ProgrammingSearchBrowser: ['programming-search-browser', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,19.628a3,3,0,0,0,3,3H16.5a3,3,0,0,0,3-3v-5.5a1,1,0,0,0-2,0v5.5a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1v-9a.5.5,0,0,1,.5-.5h8a.5.5,0,0,0,.442-.733,6.423,6.423,0,0,1-.623-1.767,6.517,6.517,0,0,1-.123-1.25c0-.077,0-.153.005-.229a.5.5,0,0,0-.5-.521H3a3,3,0,0,0-3,3Zm3.5-10.5a1,1,0,0,1-1-1,.979.979,0,0,1,.092-.408A1,1,0,0,1,3.5,7.128a.985.985,0,0,1,.846.5.969.969,0,0,1,.154.5A1,1,0,0,1,3.5,9.128Zm3.5,0a1,1,0,0,1-1-1,.969.969,0,0,1,.154-.5.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5A1,1,0,0,1,7,9.128Z', 'M12.97,18.158a.748.748,0,0,0,1.06,0l2-2a.749.749,0,0,0,0-1.06l-2-2a.75.75,0,0,0-1.06,1.06l1.293,1.293a.252.252,0,0,1,0,.354L12.97,17.1A.749.749,0,0,0,12.97,18.158Z', 'M7.03,13.1a.749.749,0,0,0-1.06,0l-2,2a.749.749,0,0,0,0,1.06l2,2A.75.75,0,0,0,7.03,17.1L5.737,15.805a.252.252,0,0,1,0-.354L7.03,14.158A.749.749,0,0,0,7.03,13.1Z', 'M10.329,13.293l-2,4A.75.75,0,0,0,8.665,18.3.741.741,0,0,0,9,18.378a.75.75,0,0,0,.672-.415l2-4a.75.75,0,1,0-1.342-.67Z', 'M23.563,12.686a1.5,1.5,0,0,0,0-2.121L22.465,9.477,21.783,8.8a.5.5,0,0,1-.113-.537,4.963,4.963,0,0,0,.35-1.817,5.073,5.073,0,1,0-5.074,5.074,4.964,4.964,0,0,0,2.268-.557.5.5,0,0,1,.581.091l.663.66.984.98a1.5,1.5,0,0,0,2.121-.006ZM16.946,9.518A3.073,3.073,0,1,1,20.02,6.444,3.076,3.076,0,0,1,16.946,9.518Z']],
  ProgrammingTeamChat: ['programming-team-chat', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.870 16.250 A3.250 3.250 0 1 0 22.370 16.250 A3.250 3.250 0 1 0 15.870 16.250 Z', 'M12.213,14.443a.738.738,0,0,0,.287.057.746.746,0,0,0,.53-.22l2.634-2.636a.5.5,0,0,1,.354-.147H19.5a1.752,1.752,0,0,0,1.75-1.75v-8A1.752,1.752,0,0,0,19.5,0H5.5A1.752,1.752,0,0,0,3.75,1.75v8A1.752,1.752,0,0,0,5.5,11.5h5.75a.5.5,0,0,1,.5.5V13.75A.75.75,0,0,0,12.213,14.443ZM15.47,4.28a.75.75,0,1,1,1.06-1.06l2,2a.749.749,0,0,1,0,1.06l-2,2a.75.75,0,1,1-1.06-1.06l1.293-1.293a.252.252,0,0,0,0-.354ZM9.53,7.22A.75.75,0,1,1,8.47,8.28l-2-2a.749.749,0,0,1,0-1.06l2-2A.75.75,0,1,1,9.53,4.28L8.237,5.573a.252.252,0,0,0,0,.354ZM11.5,8.5a.741.741,0,0,1-.334-.079.75.75,0,0,1-.336-1.006l2-4a.75.75,0,1,1,1.342.67l-2,4A.75.75,0,0,1,11.5,8.5Z', 'M1.630 16.250 A3.250 3.250 0 1 0 8.130 16.250 A3.250 3.250 0 1 0 1.630 16.250 Z', 'M.5,24H9.26a.5.5,0,0,0,.487-.611,4.99,4.99,0,0,0-9.734,0A.5.5,0,0,0,.5,24Z', 'M14.253,23.389A.5.5,0,0,0,14.74,24H23.5a.5.5,0,0,0,.487-.611,4.99,4.99,0,0,0-9.734,0Z']],
  ProgrammingTeamChat2: ['programming-team-chat-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.313,20.211a1,1,0,1,0,1.406-1.422c-.284-.281-.662-.842-.662-2.463a4.174,4.174,0,1,0-8.348,0c0,1.621-.378,2.182-.662,2.463a1,1,0,1,0,1.406,1.422,3.335,3.335,0,0,0,.462-.58.252.252,0,0,1,.366-.061c.063.05.128.1.194.144a.25.25,0,0,1-.022.424A4.952,4.952,0,0,0,14,23.389.5.5,0,0,0,14.49,24h8.76a.5.5,0,0,0,.487-.611A4.952,4.952,0,0,0,21.3,20.145a.247.247,0,0,1-.128-.206.25.25,0,0,1,.107-.218c.07-.048.138-.1.2-.151a.251.251,0,0,1,.365.061A3.341,3.341,0,0,0,22.313,20.211ZM18.883,18.5a2.169,2.169,0,0,1-2.131-1.794.248.248,0,0,1,.2-.288,3.256,3.256,0,0,0,.807-.261,2.467,2.467,0,0,0,.949-.782.25.25,0,0,1,.4-.015,4.021,4.021,0,0,0,.906.8,2.821,2.821,0,0,0,.8.382.251.251,0,0,1,.174.3A2.168,2.168,0,0,1,18.883,18.5Z', 'M8.547,20.211a1,1,0,0,0,1.406-1.422c-.284-.281-.662-.842-.662-2.463a4.174,4.174,0,0,0-8.348,0c0,1.621-.378,2.182-.662,2.463a1,1,0,0,0,1.407,1.422,3.383,3.383,0,0,0,.462-.58.251.251,0,0,1,.365-.061c.067.053.135.1.205.151a.253.253,0,0,1,.108.218.25.25,0,0,1-.129.206A4.952,4.952,0,0,0,.263,23.389.5.5,0,0,0,.75,24H9.51A.5.5,0,0,0,10,23.389a4.952,4.952,0,0,0-2.45-3.251.25.25,0,0,1-.022-.424c.066-.046.131-.094.194-.144a.252.252,0,0,1,.366.061A3.335,3.335,0,0,0,8.547,20.211ZM5.117,18.5a2.169,2.169,0,0,1-2.131-1.794.249.249,0,0,1,.2-.288,3.256,3.256,0,0,0,.807-.261,2.468,2.468,0,0,0,.949-.781.249.249,0,0,1,.4-.016,4.068,4.068,0,0,0,.906.8,2.833,2.833,0,0,0,.8.382.25.25,0,0,1,.174.3A2.167,2.167,0,0,1,5.117,18.5Z', 'M19.266,11.5a1.753,1.753,0,0,0,1.75-1.75v-8A1.753,1.753,0,0,0,19.266,0h-14a1.752,1.752,0,0,0-1.75,1.75v8a1.752,1.752,0,0,0,1.75,1.75h5.75a.5.5,0,0,1,.5.5V13.75a.748.748,0,0,0,.463.693.735.735,0,0,0,.287.057.748.748,0,0,0,.53-.22l2.634-2.636a.5.5,0,0,1,.353-.147ZM9.3,7.22A.75.75,0,1,1,8.235,8.28l-2-2a.749.749,0,0,1,0-1.06l2-2A.75.75,0,1,1,9.3,4.28L8,5.573a.25.25,0,0,0,0,.354Zm4.641-3.135-2,4a.75.75,0,0,1-.672.415.738.738,0,0,1-.334-.079A.749.749,0,0,1,10.6,7.415l2-4a.75.75,0,1,1,1.342.67Zm1.3,3.135,1.293-1.293a.25.25,0,0,0,0-.354L15.235,4.28A.75.75,0,1,1,16.3,3.22l2,2a.749.749,0,0,1,0,1.06l-2,2a.75.75,0,1,1-1.061-1.06Z']],
  ProgrammingMonitorType: ['programming-monitor-type', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13,16.046a.265.265,0,0,1-.019-.1v-1.2a.251.251,0,0,1,.249-.25c1.136-.008,5.8-.042,6.164-.042A2,2,0,0,0,20.98,12.5V2a2,2,0,0,0-2-2h-14a2,2,0,0,0-2,2V12.5a2,2,0,0,0,1.607,1.96c.345,0,5.009.031,6.145.038a.25.25,0,0,1,.248.25v1.206a.251.251,0,0,1-.016.09c-.06.155-.272.706-.505,1.264a.5.5,0,0,0,.462.692h2.151a.5.5,0,0,0,.459-.7C13.29,16.747,13.064,16.2,13,16.046ZM18.48,2a.5.5,0,0,1,.5.5v8a.5.5,0,0,1-.5.5h-13a.5.5,0,0,1-.5-.5v-8a.5.5,0,0,1,.5-.5Z', 'M9.176,16.546a.732.732,0,0,0-.358-.971,43.584,43.584,0,0,0-4.6.428c-.312-.01-.8-.009-.972.359l-2.04,3.5A2.438,2.438,0,0,0,2.4,23.1l1.479.682a2.44,2.44,0,0,0,2.345-.168C7.54,22.76,9.4,21.215,9.4,21.215a.585.585,0,0,0-.454-1.07l-1.2.55a.25.25,0,0,1-.332-.331Z', 'M20.755,16.362c-.169-.368-.66-.369-.972-.359a43.584,43.584,0,0,0-4.6-.428.732.732,0,0,0-.358.971l1.758,3.818a.25.25,0,0,1-.332.331l-1.2-.55a.585.585,0,0,0-.453,1.07s1.86,1.545,3.176,2.394a2.44,2.44,0,0,0,2.345.168L21.6,23.1a2.439,2.439,0,0,0,1.2-3.236Z']],
  ProgrammingUserChatWoman: ['programming-user-chat-woman', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,1.75A1.752,1.752,0,0,0,22.25,0h-11A1.752,1.752,0,0,0,9.5,1.75v8a1.752,1.752,0,0,0,1.75,1.75h1a.25.25,0,0,1,.25.25v2a.749.749,0,0,0,.75.75.742.742,0,0,0,.488-.181l3.219-2.759a.249.249,0,0,1,.163-.06h5.13A1.752,1.752,0,0,0,24,9.75ZM15.78,4.72a.749.749,0,0,1,0,1.06l-2,2a.75.75,0,0,1-1.06-1.06l1.293-1.293a.252.252,0,0,0,0-.354L12.72,3.78a.75.75,0,1,1,1.06-1.06ZM21.5,7.25a.75.75,0,0,1-.75.75h-3a.75.75,0,0,1,0-1.5h3A.75.75,0,0,1,21.5,7.25Z', 'M.036,23.314A.5.5,0,0,0,.5,24H11.688a.5.5,0,0,0,.464-.686c-.033-.082-.069-.165-.108-.248-.4-.846-2.068-1.433-4.163-2.254a.6.6,0,0,1-.37-.563v-.3a.25.25,0,0,1,.248-.25,4.318,4.318,0,0,0,2.667-.69.306.306,0,0,0,.131-.214.316.316,0,0,0-.071-.243c-.357-.415-.6-.915-.709-2.559C9.588,13.038,7.709,12,6.094,12S2.6,13.038,2.411,15.989c-.1,1.644-.352,2.144-.709,2.559a.316.316,0,0,0-.071.243.3.3,0,0,0,.132.214,4.311,4.311,0,0,0,2.662.7.251.251,0,0,1,.178.073.247.247,0,0,1,.074.177v.3a.6.6,0,0,1-.37.563c-2.1.821-3.764,1.408-4.163,2.254C.105,23.149.069,23.232.036,23.314Z']],
  ProgrammingHoldLaptop: ['programming-hold-laptop', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.848,18.9a.253.253,0,0,1-.123-.275l.494-2.153c.343-1.438-.971-2.052-1.688-.938a21.692,21.692,0,0,0-1.487,3.817.973.973,0,0,0-.044.293V23.75a.25.25,0,0,0,.25.25h3.5a.25.25,0,0,0,.25-.25V22.678a.5.5,0,0,1,.148-.356c.567-.561,2.615-2.589,3.558-3.528A1,1,0,0,0,24,18.085V10.939a.5.5,0,0,0-.665-.472c-.73.256-1.8,1.389-1.834,5.829a.5.5,0,0,1-.147.35l-2.208,2.209A.253.253,0,0,1,18.848,18.9Z', 'M3.861,22.324A.5.5,0,0,1,4,22.67v1.08a.25.25,0,0,0,.25.25h3.5A.25.25,0,0,0,8,23.75V19.641a.973.973,0,0,0-.044-.293,21.692,21.692,0,0,0-1.487-3.817c-.717-1.114-2.031-.5-1.688.938l.494,2.153a.25.25,0,0,1-.421.233L2.646,16.646A.5.5,0,0,1,2.5,16.3c-.032-4.44-1.1-5.573-1.834-5.829A.5.5,0,0,0,0,10.939v7.105a1,1,0,0,0,.329.741C1.364,19.722,3.325,21.763,3.861,22.324Z', 'M6.115,12.5h11.77A3.062,3.062,0,0,0,21,9.5a.5.5,0,0,0-.5-.5h-.75a.25.25,0,0,1-.25-.25v-7.1A1.649,1.649,0,0,0,17.853,0H6.147A1.649,1.649,0,0,0,4.5,1.648v7.1A.25.25,0,0,1,4.25,9H3.5a.5.5,0,0,0-.5.5A3.062,3.062,0,0,0,6.115,12.5ZM6.5,2.5A.5.5,0,0,1,7,2H17a.5.5,0,0,1,.5.5V8.75a.25.25,0,0,1-.25.25H6.75a.25.25,0,0,1-.25-.25Z']],
  ProgrammingHoldCode: ['programming-hold-code', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.609,6.787a1.249,1.249,0,0,0,0-1.767l-4-4a1.25,1.25,0,1,0-1.768,1.767L20.6,5.55a.5.5,0,0,1,0,.707L17.841,9.02a1.25,1.25,0,0,0,1.768,1.767Z', 'M10.609,1.02a1.249,1.249,0,0,0-1.768,0l-4,4a1.249,1.249,0,0,0,0,1.767l4,4A1.25,1.25,0,1,0,10.609,9.02L7.846,6.257a.5.5,0,0,1,0-.707l2.763-2.763A1.249,1.249,0,0,0,10.609,1.02Z', 'M12.954,11.624a1.264,1.264,0,0,0,.272.029,1.252,1.252,0,0,0,1.22-.978l2-9A1.251,1.251,0,0,0,14,1.132l-2,9A1.252,1.252,0,0,0,12.954,11.624Z', 'M4.969,15.9a4,4,0,0,0-1.789.423L.163,17.834a.25.25,0,0,0-.138.224v5.394a.25.25,0,0,0,.382.212l3.418-2.136a.5.5,0,0,1,.424-.05c10.252,3.436,6.773,3.495,18.1-2.236a.514.514,0,0,0,.084-.86,2.48,2.48,0,0,0-2.411-.479L16.6,19.039a.5.5,0,0,0-.29.252A1.993,1.993,0,0,1,14.525,20.4h-4a.5.5,0,1,1,0-1h4a1,1,0,0,0,0-2H11.2a.5.5,0,0,1-.3-.1,6.97,6.97,0,0,0-3.872-1.4Z']]
};
exports["default"] = _default;